import { useSettingsMapping } from 'app/components/settings-mapping/useSettingsMapping'
import { SettingsMappingComponent } from 'app/components/settings-mapping/SettingsMappingComponent'

export default function ChannelMappingPage(): React.ReactElement {
  const { title, tabs } = useSettingsMapping()
  return <SettingsMappingComponent title={title} tabs={tabs} />
}
